import styled from 'styled-components';
import { Palette } from 'config';

export const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 8px;
  gap: 8px;
  color: ${Palette.PrimaryGray._900};
  font-size: 14px;
  line-height: 20px;
`;

export const Title = styled.h3`
  margin: 0;
  margin-top: 4px;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SortGroup = styled.div`
  display: flex;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 0;
`;

export const SortButton = styled.button`
  width: ${({ isText }) => (isText ? 'auto' : '30px')};
  padding: ${({ isText }) => (isText ? '0 16px' : 'none')};
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: ${({ isActive }) =>
    isActive ? `1px solid ${Palette.Primary._300}` : `1px solid ${Palette.PrimaryGray._200}`};
  background: ${({ isActive }) => (isActive ? Palette.Primary._000 : Palette.White._000)};
  fill: currentColor;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  border-radius: 4px 0 0 4px;
  z-index: ${({ isActive }) => (isActive ? '1' : '0')};

  &:last-child {
    margin-left: -1px;
    border-radius: 0 4px 4px 0;
  }
`;

export const SelectWrap = styled.div`
  position: relative;
  display: grid;
  align-items: center;
`;

export const SelectButton = styled.button`
  height: 32px;
  min-width: 80px;
  max-width: 180px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-radius: 4px;
  background: ${Palette.White._000};
  color: ${Palette.PrimaryGray._800};
  font-size: 14px;
  line-height: 20px;
  padding: 0 12px;
  cursor: pointer;
`;

export const SelectValue = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SelectIcon = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  color: ${Palette.PrimaryGray._400};
  fill: currentColor;
  pointer-events: none;
`;
